import React from "react";
import { Pie, PieConfig } from "@ant-design/plots";
import { Props } from "./types";

function PieChart(props: Props) {
  const {
    data,
    angleField,
    colorField,
    // color = ["#ED213C", "#B93995", "rgba(0, 0, 0, 0.54)"],
  } = props;

  const config: PieConfig = {
    appendPadding: 6,
    data,
    angleField,
    colorField,
    // color,
    radius: 1,
    innerRadius: 0.66,
    height: 238,
    // width: 220,

    statistic: {
      title: false as const,
      content: false,
    },

    label: {
      type: "inner",
      offset: "-50%",
      content: "",
      // content: function content(_ref) {
      //   return "".concat(_ref.value, "%");
      // },
      style: {
        fontSize: 0,
        textAlign: "center",
      },
    },
    legend: {
      // layout: "horizontal",
      position: "right",
    },
  };
  return <Pie {...config} />;
}

export default PieChart;
